
/*----------------------
       SLIDER BANNER
---------------------- */
Sliderbanner = {
    init: function () {
      if ($(".swiper-about-banner .swiper-slide").length > 1) {
        var swiper = new Swiper(".swiper-about-banner", {
            slidesPerView: 1,
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
            },
            992: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 3,
            },
            1440: {
              slidesPerView: 4
            },
          },
        });
      }
    }
  };
  
  $(document).ready(function () {
    Sliderbanner.init();
  });
  $(document).on('shopify:section:load', function (event) {
    Sliderbanner.init();
  });
  
  